<template>
    <span>
        <span
            :class="isUnderline('th')"
            @click="changeLangTo('th')"
            class="lang-th pointer mr-1">
            ไทย
        </span>
        |
        <span
            :class="isUnderline('en')"
            @click="changeLangTo('en')"
            class="lang-en pointer">
            EN
        </span>
    </span>
</template>

<script>
export default {
    name: 'ChangeLang',

    methods: {
        isUnderline (lang) {
            if (this.$vuetify.lang.current === lang) {
                return 'text-underline'
            }
            return ''
        },

        changeLangTo (lang) {
            this.$vuetify.lang.current = lang
            localStorage.setItem('lang', lang)
        }
    },

    mounted () {
        const lang = localStorage.getItem('lang')
        if (lang) {
            this.changeLangTo(lang)
        }
    }
}
</script>

<style lang="scss" scoped>

.lang {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
    &-th{
        font-family: Prompt;
    }
    &-en{
        font-family: LexendDeca;
    }
}

.text-underline {
    text-decoration: underline;
    color: #d76436;
}

</style>
